import { ObjectValuesType } from "shared-models";

export const ToastType = {
  SUCCESS_TOAST: 'success',
  WARNING_TOAST: 'warning',
  ERROR_TOAST: 'error',
};

export type ToastType = ObjectValuesType<typeof ToastType>;
